import mem from "mem";
import axios from "axios";
import {getFingerprint} from "./auth";
import {getLocation} from "./common";

const request = axios.create({
	baseURL: process.env.REACT_APP_SERVICE_URL,
	headers: {
		'Content-Type': 'application/json',
	}
})

const refreshToken = async () => {

	const token = localStorage.getItem("reload_token");

	try {

		const [deviceId, location] = await Promise.all([
			getFingerprint(),
			getLocation()
		]);

		const response = await request.post("/auth/refresh-token", {
			refreshToken: token
		}, {
			headers: {
				"Content-Type": "application/json",
				'X-DeviceId': deviceId,
				'X-Location': location
			}
		});

		if (!response?.data?.accessToken)
		{
			localStorage.clear();
		}

		const accessToken = {
			accessToken   : response.data.accessToken,
			expires       : response.data.expires,
		}

		localStorage.setItem('access_token', JSON.stringify(accessToken));

		localStorage.setItem('reload_token', response.data.refreshToken);

		return accessToken;

	}
	catch (err) {
		localStorage.clear();
	}
};

const maxAge = 10000;

export const memoizedRefreshToken = mem(refreshToken, {
	maxAge,
});